<template>
  <v-data-table
    :headers="applicationSiteHeaders"
    :items="applicationSites"
    disable-sort
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-row align="center">
          <v-col class="text-subtitle-2 gray--text text--lighten-1">
            Locais de aplicação
          </v-col>

          <v-col cols="auto">
            <v-btn
              color="light-blue"
              :dark="positionsChanged"
              @click="savePositions"
              :disabled="!positionsChanged"
              :loading="isSavingPositions"
            >
              Salvar Ordenação
            </v-btn>
          </v-col>

          <v-col cols="auto">
            <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
                  Novo local de aplicação
                </v-btn>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="editedItem.name"
                          label="Nome"
                          :hide-details="!errors.editedItem"
                          :error-messages="errors.editedItem"
                        />
                      </v-col>
                    </v-row>
                    <v-row dense align="end">
                      <v-col cols="auto">
                        <v-switch
                          v-model="editedItem.showNameInPrescriptionActions"
                          label="Mostrar na posologia"
                          hide-details
                        />
                      </v-col>
                      <v-col cols="auto">
                        <v-tooltip bottom>
                          <template
                            v-slot:activator="{
                              on: tooltipListeners,
                              attrs: tooltipAttrs,
                            }"
                          >
                            <v-icon
                              v-bind="tooltipAttrs"
                              v-on="tooltipListeners"
                            >
                              eva-info-outline
                            </v-icon>
                          </template>
                          <div
                            :style="{
                              lineHeight: '0.3em',
                              paddingTop: '1em',
                            }"
                          >
                            <p>Mostrar na podologia da receita.</p>
                            <p>Se habilitado, ficará:</p>
                            <p>
                              "Aplicar X unidades X vezes ao dia por X dias
                              <strong>{{ editedItem.name }}</strong
                              >"
                            </p>
                            <p>Se desabilitado, ficará:</p>

                            <p>
                              "Aplicar X unidades X vezes ao dia por X dias"
                            </p>
                          </div>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_facilitator_medicine"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="moveDown(item)">
          eva-arrow-down-outline
        </v-icon>

        <v-icon v-if="authorization" small class="mr-2" @click="moveUp(item)">
          eva-arrow-up-outline
        </v-icon>

        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>

        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há dados cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  const DEFAULT_ITEM = {
    name: "",
    showNameInPrescriptionActions: true,
  };

  import {
    repositionDown,
    repositionUp,
  } from "@/components/config/medicine/application_route/item/reposition_application_sites.js";

  export default {
    name: "PresentationActionTable",
    props: {
      applicationRoute: Object,
      refreshList: Function,
    },
    data() {
      return {
        errors: {},
        dialog: null,
        editedItem: { ...DEFAULT_ITEM },
        applicationSites: [],
        editedIndex: -1,
        applicationSiteHeaders: [
          { text: "Nome", value: "name" },
          { text: "Ações", value: "actions", align: "end" },
        ],
        positionsChanged: false,
        isSavingPositions: false,
      };
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1
          ? "Novo local de aplicação"
          : "Editar local de aplicação";
      },
    },
    mounted() {
      this.applicationSites = this.applicationRoute.applicationSites;
    },
    watch: {
      applicationRoute(applicationRoute) {
        this.applicationSites = applicationRoute.applicationSites;
      },
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.applicationSites.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/medicine/delete_application_site.gql"),
            variables: {
              applicationSiteId: item.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Facilitador deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = { ...DEFAULT_ITEM };
          this.editedIndex = -1;
        });
      },
      save() {
        if (!this.validate()) return;

        const { showNameInPrescriptionActions } = this.editedItem;

        this.apolloMutate({
          mutation: require("@/graphql/medicine/save_application_site.gql"),
          variables: {
            applicationRouteId: this.applicationRoute.id,
            applicationSiteId: this.lodash.get(this.editedItem, "id", ""),
            showNameInPrescriptionActions,
            name: this.editedItem.name,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      async savePositions() {
        const sitesPositions = this.applicationSites.map((site) => ({
          id: site.id,
          position: site.position,
        }));

        this.isSavingPositions = true;

        await this.apolloMutate({
          mutation: require("@/graphql/medicine/save_application_sites_positions.gql"),
          variables: {
            sitesPositions,
          },
        });

        await this.refreshList();

        this.isSavingPositions = false;
        this.positionsChanged = false;
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let name = this.editedItem.name;
        if (this.lodash.isEmpty(name?.trim())) {
          this.errors.editedItem = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
      moveUp(element) {
        const index = this.findApplicationSiteIndex(element);
        this.applicationSites = repositionUp(this.applicationSites, index);
        this.positionsChanged = true;
      },
      moveDown(element) {
        const index = this.findApplicationSiteIndex(element);
        this.applicationSites = repositionDown(this.applicationSites, index);
        this.positionsChanged = true;
      },
      findApplicationSiteIndex(element) {
        return this.applicationSites.findIndex(({ id }) => id === element.id);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
